import { useState } from "react";
import { teaPosts } from "@/mocks/homeData";

export default function TeaHouse() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [comment, setComment] = useState("");

  const toggle = (floor: string) => setLiked((p) => ({ ...p, [floor]: !p[floor] }));

  return (
    <section id="tea" className="bg-background-100/80 py-14 md:py-20">
      <div className="mx-auto max-w-5xl px-4 md:px-6">
        <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium tracking-wider text-secondary-800">
              <i className="ri-cup-line text-secondary-700"></i>
              茶水间实时弹幕
            </span>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-[34px]">
              围观茶馆 · 高楼前排都是谁
            </h2>
            <p className="mt-3 text-sm text-foreground-600 md:text-base">
              最新回复实时滚动，评论来自天南地北的围观群众。
            </p>
          </div>
          <span className="mb-1 inline-flex items-center gap-2 rounded-full bg-background-50 px-4 py-2 text-xs text-foreground-500 ring-1 ring-background-200">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-60"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            {teaPosts.length + 182} 人在此楼
          </span>
        </div>

        {/* comment list */}
        <div className="mt-8 space-y-3">
          {teaPosts.map((p) => (
            <article key={p.floor + p.user} className="rounded-2xl border border-background-200 bg-background-50 p-4 md:p-5">
              <div className="flex flex-wrap items-center gap-3">
                <img src={p.avatar} alt={p.user} className="h-10 w-10 rounded-full object-cover" />
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <p className="text-sm font-semibold text-foreground-950">{p.user}</p>
                    {p.tag && (
                      <span className={`rounded-md px-1.5 py-0.5 text-[10px] ${p.tag === "版主" ? "bg-primary-100 text-primary-800" : "bg-accent-100 text-accent-900"}`}>
                        {p.tag}
                      </span>
                    )}
                    {p.floor && (
                      <span className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-800">{p.floor}</span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-400">{p.time}</span>
                </div>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-800">{p.content}</p>
              <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                <button
                  onClick={() => toggle(p.floor + p.user)}
                  className={`inline-flex items-center gap-1.5 transition ${liked[p.floor + p.user] ? "text-primary-600" : "hover:text-primary-600"}`}
                >
                  <i className={liked[p.floor + p.user] ? "ri-heart-fill" : "ri-heart-line"}></i>
                  {(p.like + (liked[p.floor + p.user] ? 1 : 0)).toLocaleString()}
                </button>
                <button className="inline-flex items-center gap-1.5 transition hover:text-primary-600">
                  <i className="ri-chat-4-line"></i>
                  {p.replies}
                </button>
                <span className="ml-auto inline-flex items-center gap-1 text-foreground-400">
                  <i className="ri-flag-line"></i> 举报
                </span>
              </div>
            </article>
          ))}
        </div>

        {/* quick reply box */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setComment("");
          }}
          className="mt-4 rounded-2xl border border-background-200 bg-background-50 p-4"
        >
          <p className="mb-2 text-xs font-medium text-foreground-600">说说你的看法（本页为演示，不真正提交）</p>
          <div className="flex flex-col gap-3 sm:flex-row">
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              maxLength={120}
              rows={1}
              placeholder="理性讨论，瓜才有得吃…"
              className="flex-1 resize-none rounded-xl border border-background-200 bg-background-100 px-4 py-3 text-sm outline-none transition placeholder:text-foreground-400 focus:border-primary-300 focus:bg-background-50"
            />
            <button
              type="submit"
              className="whitespace-nowrap rounded-xl bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600 sm:rounded-full"
            >
              跟一帖
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}